module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/1-e237ad5525817487f3623e38b4113a3f.jpg";